import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { CustomizationService } from '../modules/customization/customization.service';
import { AuthService } from '../modules/auth/auth.service';
import { isEmpty } from 'ramda/es';
import { ThemeService } from './theme.service';
import { eva_constants } from '../eva_constants';

@Injectable()
export class ThemeResolver implements Resolve<any> {
  constructor(
    private router: Router,
    private customizationService: CustomizationService,
    private authService: AuthService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const user = this.authService.getUser() || {};
    if (!isEmpty(user)) {
      try {
        return this.customizationService
          .getAccountTag(eva_constants.ACCOUNT_TYPE_TAG)
          .map(x => {
            if (x && x.value) return x.value;
            return null;
          })
          .catch(() => {
            return Observable.of(null);
          });
      } catch (err) {
        console.log(err);
        return Observable.of(null);
      }
    } else {
      if (window && window.location && window.location.href && window.location.href) {
        var aLink = document.createElement('a');
        aLink.href = window.location.href;
        return Observable.of(
          aLink.hostname.indexOf(eva_constants.HOST_MYLIVE) >= 0
            ? eva_constants.MYLIVETV_THEME
            : eva_constants.EVA_THEME
        );
      } else return Observable.of(null);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/theme.resolver.ts